import React from 'react';
import Link, { LinkProps } from '@mui/material/Link';

export type LinkButtonProps = Pick<LinkProps, 'children' | 'underline' | 'variant' | 'color' | 'style' | 'sx' | 'onClick' | 'href' | 'target' | 'variant'> & {
	component?: React.ElementType;
}

/** A button that looks like a link */
export function LinkButton({ component, variant, ...otherProps }: LinkButtonProps) {
	return <Link component={component ?? "button"} variant={variant ?? "body2"} {...otherProps} />;
}
